import React, { FC } from 'react';

import { Flex } from '@adsk/alloy-react-box';

import ProjectsHeaderTabs from './ProjectsHeaderTabs';
import ProjectsHeaderTitles from './ProjectsHeaderTitles';

const ProjectsHeader: FC = () => {
  return (
    <>
      <Flex
        m="0 48px"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        justifyItems="center"
      >
        <ProjectsHeaderTitles />
      </Flex>
      <ProjectsHeaderTabs />
    </>
  );
};

export default ProjectsHeader;
